import Icon from '../components/Icon.vue'

Icon.register({
  kiss: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM304 396c0-13-13.4-27.3-35.2-36.4 21.8-8.7 35.2-23 35.2-36 0-19.2-28.7-41.5-71.5-44-8.4-1.1-12.2 11.8-3.6 15.4l17 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.8 21.5l-17 7.2c-6.1 2.6-6 12.3 0 14.8l17 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.8 21.5l-17 7.2c-8.5 3.6-4.9 16.2 3.6 15.4 42.8-2.5 71.5-24.8 71.5-44zM328 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/kiss.js
// module id = 1501
// module chunks = 0